var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotoButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 180"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 218",
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FF5234"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 104",
    d: "M23.5723 33.8574L23.5723 14.1431",
    stroke: "white",
    strokeWidth: 5.14286
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 104_2",
    d: "M13.7148 24.0012H33.4291",
    stroke: "white",
    strokeWidth: 5.14286
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoButton);
export default __webpack_public_path__ + "static/media/PhotoButton.a1a956bf406656dcd0e373ecc5d9cfc6.svg";
export { ForwardRef as ReactComponent };